import type { IGameEvent, IQueueEvent } from "../types";

export const eventQueueTransformer = (event: IGameEvent): IQueueEvent => {
  const eventCopy = { ...event };
  let hitData = null;
  let pitchData = null;

  if (eventCopy?.pitch_data !== null) {
    pitchData = {
      RelSpeedMPH: eventCopy?.pitch_data?.RelSpeedMPH,
      SpinRateRPM: eventCopy?.pitch_data?.SpinRateRPM,
      yt_SpinEfficiencyPercent: eventCopy?.pitch_data?.yt_SpinEfficiencyPercent,
      Tilt: eventCopy?.pitch_data?.Tilt,
      SpinAxisDegrees: eventCopy?.pitch_data?.SpinAxisDegrees,
      VertBreakInches: eventCopy?.pitch_data?.VertBreakInches,
      HorzBreakInches: eventCopy?.pitch_data?.HorzBreakInches,
      InducedVertBreakInches: eventCopy?.pitch_data?.InducedVertBreakInches,
      yt_VertApprAngleDegrees: eventCopy?.pitch_data?.yt_VertApprAngleDegrees,
      HorzApprAngleDegrees: eventCopy?.pitch_data?.HorzApprAngleDegrees,
      yt_RelHeightFeet: eventCopy?.pitch_data?.yt_RelHeightFeet,
      RelSideFeet: eventCopy?.pitch_data?.RelSideFeet,
      RelHeightFeet: eventCopy?.pitch_data?.RelHeightFeet,
      ExtensionFeet: eventCopy?.pitch_data?.ExtensionFeet,
      PlateLocHeightFeet: eventCopy?.pitch_data?.PlateLocHeightFeet,
      PlateLocSideFeet: eventCopy?.pitch_data?.PlateLocSideFeet,
      PlateEpochSeconds: eventCopy?.pitch_data?.plateEpochSeconds,
      ZoneAccuracy: eventCopy?.pitch_data?.ZoneAccuracy,
      PlateLocHeightSZRelative: eventCopy?.pitch_data?.PlateLocHeightSZRelative,
      PlateLocSideSZRelative: eventCopy?.pitch_data?.PlateLocSideSZRelative,
      AutoPitchCall: eventCopy?.pitch_data?.AutoPitchCall,
      ZoneSpeedMPH: eventCopy?.pitch_data?.ZoneSpeedMPH,
      ZoneTimeSeconds: eventCopy?.pitch_data?.ZoneTimeSeconds,
    };
  }

  if (eventCopy.hit_data !== null) {
    hitData = {
      ExitSpeedMPH: eventCopy?.hit_data?.ExitSpeedMPH,
      DistanceFeet: eventCopy?.hit_data?.DistanceFeet,
      HangTimeSeconds: eventCopy?.hit_data?.HangTimeSeconds,
      HitSpinRateRPM: eventCopy?.hit_data?.HitSpinRateRPM,
      AngleDegrees: eventCopy?.hit_data?.AngleDegrees,
      BearingDegrees: eventCopy?.hit_data?.BearingDegrees,
      DirectionDegrees: eventCopy?.hit_data?.DirectionDegrees,
      ExitEpochSeconds: eventCopy?.hit_data?.exitEpochSeconds,
      yt_HitLocationXFeet: eventCopy?.hit_data?.yt_HitLocationXFeet,
      yt_HitLocationYFeet: eventCopy?.hit_data?.yt_HitLocationYFeet,
      yt_GroundLocationXFeet: eventCopy?.hit_data?.yt_GroundLocationXFeet,
      yt_GroundLocationYFeet: eventCopy?.hit_data?.yt_GroundLocationYFeet,
    };
  }

  const cleanEvent = {
    contributing_events: eventCopy.contributing_events,
    event_uuid: eventCopy.event_uuid,
    event_time: eventCopy.event_time,
    pitchUUID: eventCopy.pitchUUID,
    pitch_data: pitchData,
    hit_data: hitData,
    ball: eventCopy.ball,
    tagData: null,
    serverTime: eventCopy.server_time_now,
    configured_strike_zone: eventCopy.configured_strike_zone ?? null,
    strike_zone_data: eventCopy.strike_zone_data ?? null,
    aero_data: eventCopy.aero_data ?? null,
  };

  return cleanEvent as IQueueEvent;
};
